import React from "react";

function Loader() {
  return (
    <>
    <div className="loader">
        <div className="dbl-spinner"></div>
        <div className="dbl-spinner dbl-spinner--2"></div>
    </div>
    </>
  );
}

export default Loader;
